<template>
  <rest-page>
    <page-header-new :title="pageTitle" :breadcrumbs="breadcrumbs" />
    <page-content>
      <p class="intro">{{ $t('InternalApiDocs_Intro') }}</p>

      <div class="services-diagram">
        <div class="service-box service-box-hub">
          {{ hubService.name }}
        </div>
        <div class="services-diagram-connections">
          <div
            class="services-diagram-connection"
            v-for="service in peerServices"
            :key="service.key"
          >
            <div class="services-diagram-arrow">
              <i class="el-icon-arrow-left" />
              <i class="el-icon-arrow-right" />
            </div>
            <div class="service-box">{{ service.name }}</div>
          </div>
        </div>
      </div>
      <p class="diagram-caption">{{ $t('InternalApiDocs_DiagramCaption') }}</p>

      <div class="service-list">
        <div
          class="service-card"
          v-for="service in services"
          :key="service.key"
        >
          <div class="service-card-header">
            <span class="service-card-name">{{ service.name }}</span>
            <el-tag
              v-if="service.status === serviceStatusEnum.COMING_SOON"
              size="mini"
              type="info"
            >
              {{ $t('InternalApiDocs_ComingSoon') }}
            </el-tag>
          </div>
          <p class="service-card-description">{{ service.description }}</p>
          <p v-if="service.note" class="service-card-note">
            {{ service.note }}
          </p>
          <el-link
            v-if="service.status === serviceStatusEnum.LIVE"
            :href="service.specUrl"
            target="_blank"
            type="primary"
            :underline="false"
          >
            {{ $t('InternalApiDocs_ViewSpec') }}
            <i class="el-icon-top-right" />
          </el-link>
        </div>
      </div>
    </page-content>
  </rest-page>
</template>

<script>
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageContent from '@/common/components/page/PageContent'
import RestPage from '@/common/components/rest/RestPage.vue'
import { serviceStatusEnum } from '@/modules/settings/enum/ServiceStatusEnum'

export default {
  name: 'InternalApiDocsPage',

  components: {
    RestPage,
    PageHeaderNew,
    PageContent
  },

  computed: {
    serviceStatusEnum() {
      return serviceStatusEnum
    },

    pageTitle() {
      return this.$t('InternalApiDocs_Title')
    },

    breadcrumbs() {
      return [
        { label: this.$t('Settings_Breadcrumb_Settings') },
        { label: this.pageTitle }
      ]
    },

    hubService() {
      return {
        key: 'internal-api',
        name: this.$t('InternalApiDocs_Service_InternalApi_Name'),
        description: this.$t('InternalApiDocs_Service_InternalApi_Description'),
        specUrl: '/internal-api-docs/view',
        status: serviceStatusEnum.LIVE
      }
    },

    peerServices() {
      return [
        {
          key: 'loyalty',
          name: this.$t('InternalApiDocs_Service_Loyalty_Name'),
          description: this.$t('InternalApiDocs_Service_Loyalty_Description'),
          note: this.$t('InternalApiDocs_Service_Loyalty_Note'),
          specUrl: 'https://p.test.loyalty.xpu.sh/api#/',
          status: serviceStatusEnum.LIVE
        },
        {
          key: 'gamification',
          name: this.$t('InternalApiDocs_Service_Gamification_Name'),
          description: this.$t(
            'InternalApiDocs_Service_Gamification_Description'
          ),
          specUrl: '/internal-api-docs/view?service=gamification',
          status: serviceStatusEnum.LIVE
        },
        {
          key: 'mxa',
          name: this.$t('InternalApiDocs_Service_Mxa_Name'),
          description: this.$t('InternalApiDocs_Service_Mxa_Description'),
          specUrl: null,
          status: serviceStatusEnum.COMING_SOON
        }
      ]
    },

    services() {
      return [this.hubService, ...this.peerServices]
    }
  }
}
</script>

<style scoped lang="scss">
.intro {
  margin: 0 0 24px;
  max-width: 800px;
  color: #606266;
}

.services-diagram {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.services-diagram-connections {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.services-diagram-connection {
  display: flex;
  align-items: center;
  gap: 8px;
}

.services-diagram-arrow {
  font-size: 18px;
  color: #909399;
  display: flex;
  gap: 2px;
}

.diagram-caption {
  margin: 8px 0 32px;
  max-width: 800px;
  color: #909399;
  font-size: 13px;
}

.service-box {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px 16px;
  background: #f5f7fa;
  font-weight: 500;
  text-align: center;
}

.service-box-hub {
  background: #ecf5ff;
  border-color: #b3d8ff;
  padding: 20px 24px;
  font-size: 16px;
}

.service-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.service-card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 16px;
}

.service-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.service-card-name {
  font-weight: 600;
}

.service-card-description {
  color: #606266;
  min-height: 60px;
}

.service-card-note {
  color: #909399;
  font-size: 12px;
  font-style: italic;
  margin: 0 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/pages/InternalApiDocsPage.vue